
import Vue from 'vue'
import RIcon from '@/components/icons/index.vue'
import RButton from '@/components/forms/RButton.vue'
import { mapActions } from 'vuex'

export default Vue.extend({
  name: 'GoBack',
  components: {
    RIcon,
    RButton,
  },
  props: {
    to: {
      type: String,
    },
    title: {
      type: String,
      default: 'Go back',
    },
    shouldLogOut: {
      type: Boolean,
    },
  },
  computed: {
    absolute(): boolean {
      return this.to?.startsWith('htt')
    },
    isRouterLink(): boolean {
      return !!(this.to && !this.absolute)
    },
    tag(): string {
      if (this.isRouterLink) {
        return 'router-link'
      }
      return 'a'
    },
    href(): string | null {
      return !this.isRouterLink && this.to ? this.to : null
    },
    routerTo(): string | null {
      return this.isRouterLink ? this.to : null
    },
  },
  methods: {
    goBack(): null | void {
      if (this.to) return null
      if (this.shouldLogOut) {
        this['user/logOut']()
        return
      }
      this.$router.go(-1)
    },
    ...mapActions(['user/logOut']),
  },
})
